/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import cx from 'classnames';
import Serial from './Serial';
import style from './Highlight.scss';

class Highlight extends Component {
  // static getDerivedStateFromProps(props, prevState) {
  //   if (props.active !== prevState.hovered) {
  //     return { hovered: props.active };
  //   }
  //   return null;
  // }

  // constructor(props) {
  //   super(props);
  //   this.state = { hovered: true };
  // }

  componentDidUpdate(prevProps) {
    const {
      hovered,
      onActivate = () => null,
      onDeactivate = () => null,
    } = this.props;
    if (hovered && !prevProps.hovered) {
      onActivate();
    }
    if (!hovered && prevProps.hovered) {
      onDeactivate();
    }
  }

  render() {
    const { annotation, active } = this.props;
    const { geometry, data } = annotation;

    return (
      <div
        data-serial={data ? data.checklistItemSerial : null}
        className={cx(style.highlight, {
          [style.active]: active,
        })}
        style={{
          position: 'absolute',
          left: `${geometry.x}%`,
          top: `${geometry.y}%`,
          height: `${geometry.height}%`,
          width: `${geometry.width}%`,
        }}
      >
        {data && data.checklistItemSerial ? (
          <Serial
            checklistItemSerial={data.checklistItemSerial}
            active={active}
          />
        ) : null}
      </div>
    );
  }
}

export default Highlight;
